import styled from 'styled-components';

export const LinkText = styled.span`
  font: 400 14px/22px ${({ theme }) => theme.fonts.join()};
  color: ${({ theme }) => theme.colors.palette.modifiedMalibuBlue};
  cursor: pointer;
`;
